<template>
  <div>
    <vue-headful title="Account verwijderen" />
    <Header page_title="Account verwijderen" />
    <div class="px-4 mx-2 pb-3 pt-4">
      <div class="app-body container-fluid">
        <NotificationContainer />
        <div class="pb-2">
          <p class="mb-4">
            Wanneer je account is verwijderd, kun je hier niet meer mee inloggen. We kunnen je account ook niet meer herstellen.
          </p>
          <p class="mb-4">
            Wil je (tijdelijk) geen berichten meer krijgen? Geef dan in je kalender aan dat je voorlopig niet beschikbaar bent of pas je notificaties aan.
            Klik hieronder om je account definitief te verwijderen.
          </p>
        </div>
        <button
          @click="deleteUser"
          type="button"
          class="btn btn-danger btn-block"
          v-ripple="'rgba(255, 255, 255, 0.35)'"
        >
          Ja, verwijder mijn account
        </button>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  data: function() {
    return {};
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {}
  },
  computed: {
    email() {
      let user = JSON.parse(localStorage.getItem("user"));
      return user.email;
    },
    type() {
      let user = JSON.parse(localStorage.getItem("user"));
      return user.type;
    }
  }
};
</script>

<style scoped></style>
